import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { site, waLink, waGeneralMessage } from "../data/store";

const navItems = [
  { to: "/", label: "Beranda", id: "beranda" },
  { to: "/produk", label: "Kategori Barang", id: "produk" },
  { to: "/tentang", label: "Tentang", id: "tentang" },
  { to: "/kontak", label: "Kontak", id: "kontak" },
];

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 shadow-sm backdrop-blur">
      <div className="mx-auto flex max-w-[1200px] items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center gap-3"
          aria-label={`${site.name} — beranda`}
        >
          <img
            src={site.logoMarkUrl || site.logoUrl}
            alt="Logo Nuansa Jaya Abadi"
            width="80"
            height="40"
            className="h-10 w-auto object-contain"
          />
          <span className="text-lg font-bold text-navy">{site.name}</span>
        </Link>

        <nav aria-label="Navigasi utama" className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.id}`}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition-colors duration-300 ${
                  isActive
                    ? "bg-slate-100 text-navy"
                    : "text-slate-600 hover:text-navy"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href={waLink(waGeneralMessage)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-button"
            className="ml-2 inline-flex items-center gap-2 rounded-full bg-wa px-4 py-2 text-sm font-semibold text-white transition-colors duration-300 hover:bg-wa-dark"
          >
            <MessageCircle className="h-4 w-4" aria-hidden="true" />
            Chat WhatsApp
          </a>
        </nav>

        <button
          type="button"
          data-testid="mobile-menu-toggle"
          aria-label={open ? "Tutup menu" : "Buka menu"}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
          className="rounded-md p-2 text-navy hover:bg-slate-100 md:hidden"
        >
          {open ? <X className="h-6 w-6" aria-hidden="true" /> : <Menu className="h-6 w-6" aria-hidden="true" />}
        </button>
      </div>

      {open && (
        <nav aria-label="Navigasi seluler" className="border-t border-slate-200 bg-white px-4 pb-4 md:hidden">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`mobile-nav-${item.id}`}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block rounded-md px-3 py-3 text-base font-medium ${
                  isActive ? "bg-slate-100 text-navy" : "text-slate-600"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href={waLink(waGeneralMessage)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-nav-whatsapp-button"
            className="mt-2 flex items-center justify-center gap-2 rounded-full bg-wa px-4 py-3 text-base font-semibold text-white"
          >
            <MessageCircle className="h-5 w-5" aria-hidden="true" />
            Chat WhatsApp
          </a>
        </nav>
      )}
    </header>
  );
}
